/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable quotes */
/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable react-perf/jsx-no-new-object-as-prop */
import React from 'react'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'
import { Text } from '@usap/uicomponents'
import IcoMoon from './IcoMoon'
import Box from './Box'
import { CloseIcon } from './Icons/default-icons'

const darkBorderColor = props => props.theme.global.colors['dark-4']; //#939398
const placeholderColor = props => props.theme.global.colors['placeholderColor'];

const CustomOutlinedLabel = styled.label`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "default")};

  /* Overwite mui style for floating text field. Only applicable for WMo enabled*/
  &.pure-material-textfield-outlined-wmo {
    flex-grow: 1;
    --pure-material-safari-helper1: #282828;
    --pure-material-primary-rgb: #282828;
    --pure-material-onsurface-rgb: #282828;
  }

  &.pure-material-textfield-outlined-wmo
  > textarea:not(:focus):placeholder-shown,
  &.pure-material-textfield-outlined-wmo > input:not(:focus):placeholder-shown {
    border-color: ${({ hasError }) => (hasError ? '#C33' : darkBorderColor)};
  }

  &.pure-material-textfield-outlined-wmo > input:focus,
  &.pure-material-textfield-outlined-wmo > textarea:focus {
    border-bottom-color: #282828;
    border-left-color: #282828;
    border-right-color: #282828;
    border-top: none;
    box-shadow: none;
  }

  &.pure-material-textfield-outlined-wmo>input,
  &.pure-material-textfield-outlined-wmo>textarea{
    padding: 11px 13px 11px;
  }

  &.pure-material-textfield-outlined-wmo>input:not(:focus):placeholder-shown+span{
    line-height: 58px;
    padding-left: ${({ icon }) => icon ? '25px' : '0px'};
  }
`

const FloatingInput = props => {
  const {
    resetClick = () => { },
    phoneMask = false,
    hasFocus,
    paddingRight = 46,
    cross,
    tooltip = false,
    isCheckOutSignInWmo = false,
    hasError = false,
    isWmoEnabled = false,
    ...restProps
  } = props

  const {
    error = '',
    label = '',
    placeholder = ' ',
    required = true,
    disabled = false,
    icon,
  } = restProps

  const resetHandler = event => {
    setTimeout(() => resetClick(event), 300)
  }

  return (
    <>
      <CustomOutlinedLabel
        style={{ position: 'relative' }}
        className={`pure-material-textfield-outlined ${isWmoEnabled && 'pure-material-textfield-outlined-wmo'}`}
        hasError={hasError}
        disabled={disabled}
        isCheckOutSignInWmo={isCheckOutSignInWmo}
        icon={icon}
      >
        {icon && (
          <div style={{ position: 'absolute', left: 10, top: '60%', transform: 'translateY(-50%)' }}>
            {icon}
          </div>
        )}
        {phoneMask ? (
          <NumberFormat
            className="floatingInput"
            style={{ paddingRight: hasFocus ? '66px' : '46px' }}
            placeholder={placeholder}
            format="(###) ###-####"
            mask="_"
            {...restProps}
          />
        ) : (
          <input
            className="floatingInput"
            style={{
              paddingRight:
                tooltip && hasFocus ? paddingRight + 20 : paddingRight,
              height: isCheckOutSignInWmo && '48px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: hasError && !hasFocus && '#C33',
            }}
            placeholder={placeholder}
            {...restProps}
          />
        )}
        <span
          style={{
            color: hasError && !hasFocus && '#C33',
            paddingLeft: isCheckOutSignInWmo && '3px',
          }}
        >
          {label}
          {' '}
          {required && (
            <span style={{ color: 'red', padding: '0 6px' }}>*</span>
          )}
        </span>
        {hasFocus && cross && (
          <Box
            style={{
              position: 'absolute',
              top: isWmoEnabled ? 18 : 20,
              right: tooltip ? 40 : 16,
              cursor: 'pointer',
            }}
            onMouseDown={resetHandler}
            onTouchStart={resetHandler}
          >
            <IcoMoon
              icon={CloseIcon}
              size="24px"
              color={isWmoEnabled ? 'dark-2' : 'royalBlue'}
            />
          </Box>
        )}
      </CustomOutlinedLabel>
      {isWmoEnabled && error && (
        <Text
          style={{ display: 'block' }}
          color="status-critical"
          size="xsmall"
        >
          {error}
        </Text>
      )}
    </>
  )
}
export default FloatingInput
